// extracted by mini-css-extract-plugin
export default {"profileCard":"Profile_profileCard__Gb+jx"};